var map = {
	"./de/translation.json": [
		778,
		778
	],
	"./en/translation.json": [
		362,
		362
	],
	"./es/translation.json": [
		89,
		89
	],
	"./fr/translation.json": [
		633,
		633
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 664;
module.exports = webpackAsyncContext;